var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"subheading font-weight-bold iconColor--text"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('div',{staticClass:"body-1 iconColor--text"},[_vm._v("\n    "+_vm._s(_vm.caption)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }